import styled, { css } from 'styled-components'
import { MEDIA } from 'utils/constants'
import { Checkbox } from 'components/forms'

import { assetPrefix } from 'config/env_config'

// Media query
const { DESKTOP_UP, MOBILE_UP, MOBILE } = MEDIA

export const ActionArea = styled.div``

export const Container = styled.div`
  ${({ gap }) => css`
    align-items: center;
    justify-content: space-between;
    display: flex;
    width: 100%;
    gap: ${gap || 0};

    @media screen and (max-width: 1200px) {
      width: unset;
      gap: 16px;
    }
  `}
`

export const Photo = styled.div`
  ${({ size, src, setDefaultPhoto }) => css`
    width: ${size || '40px'};
    height: ${size || '40px'};
    border-radius: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    background-image: url("${src}");
    background-size: ${setDefaultPhoto ? 'contain' : 'cover'};
    background-repeat: no-repeat;
    background-position: center center;

    @media screen and (max-width: 1200px) {
      width: 40px;
      height: 40px;
    }

  `}
`
export const Option = styled.div`
  right: 16px;
`
export const ServiceOption = styled(Option)`
  @media screen and ${DESKTOP_UP} {
    right: calc(50% - 20px);
    bottom: 24px;
  }
`

export const AllAdditionalCheckboxContainer = styled.div`
  ${Checkbox} {
    input:checked ~ label::before {
      background: var(--cobasi-blue-light-8);
    }
  }

  div {
    margin-top: 16px;
    label {
      color: var(--gray-5);
      font-family: var(--primary-font);
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 145%;
    }
  }
`

export const CheckList = styled.div`
  ${Checkbox} {
    input:checked ~ label::before {
      background: var(--cobasi-blue-light-8);
    }
  }

  margin-left: 24px;
  div {
    margin: 20px 0px;
    label {
      color: var(--gray-5);
      font-family: var(--primary-font);
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 145%;
    }
  }
`

export const TextareaContainer = styled.div`
  position: relative;
  label {
    position: absolute;
    top: 18px;
    left: 14px;
    background-color: var(--the-white);
    color: var(--gray-5);
    font-family: var(--primary-font);
    font-size: 14px;
    line-height: 19.07px;
    padding: 4px;
    z-index: 1;
  }

  scroll-margin-top: 88px;

  @media screen and ${DESKTOP_UP} {
    max-width: 704px;
    width: 100%;
  }

  @media screen and (max-width: 1200px) {
    width: 100%;
  }

  @media screen and (max-width: 1200px) {
    :focus-within {
      padding-top: 8px;
      label {
        margin-top: 8px;
      }
    }
  }
`

export const ObsTextArea = styled.textarea`
  resize: none;
  width: 100%;
  min-height: 98px;
  padding: 16px;
  color: var(--gray-5);
  font-family: var(--primary-font);
  font-size: 16px;
  font-weight: 400;
  line-height: 21.79px;
  border-color: var(--dim-gray);
  margin-top: 16px;
  border-radius: 8px;
  ::placeholder {
    color: var(--gray-7);
    max-height: 108px;
  }
`

export const Counter = styled.div`
  text-align: end;
  font-family: var(--primary-font);
  font-size: 12px;
  font-weight: 400;
  color: var(--gray-7);
  margin-top: -4px;
  margin-right: 16px;
  line-height: normal;
`

export const TextInfo = styled.div`
  ${({ isService }) => css`
    display: flex;
    flex-direction: column;
    gap: 4px;

    span:first-of-type {
      font-size: 16px;
      font-weight: 600;
      line-height: 19.2px;
      font-family: var(--primary-font);
    }

    span:last-of-type {
      font-size: 13px;
      font-weight: 400;
      line-height: 17.7px;
      font-family: var(--primary-font);
    }

    ${isService && css`
      span:last-of-type {
        font-size: 14px;
        font-weight: 600;
        line-height: 16.8px;

        text-align: center;
        margin: 16px 0 24px 0;

        @media screen and (max-width: 1200px) {
          margin: unset;
          text-align: start;
        }
      }
    `}


    @media screen and (max-width: 1200px) {
      max-width: 144px;
      span {
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  `}
`

export const PageContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media screen and (max-width: 1040px) {
    padding: 0 16px;
  }
`

export const AlignWrappers = styled.div`
  width: 100%;
  max-width: 1040px;
  margin-bottom: 24px;

`

export const WrapperTitle = styled.div`
  font-family: var(--primary-font);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: var(--gray-2);
  padding-top: 16px;

  ${({ isServices }) => isServices && css`
    font-size: 16px;
    line-height: 19.2px;
  `}

  ${({ hasSelectedPet }) => hasSelectedPet && css`
    @media screen and (max-width: 1200px) {
      display: none;
    }
  `}

  @media screen and (max-width: 768px) {
    margin-bottom: 8px
  }
`

export const WrapperElements = styled.div`
  display: flex;
  gap: 16px;
  border-radius: 2.4rem;
  margin-top: 24px;
  max-width: 752px;
  width: 100%;

  flex-wrap: wrap;

  @media screen and (max-width: 1200px) {
    max-width: unset;
  }

  position: relative;
`

export const WrapperServices = styled.div`
  display: flex;
  max-width: 752px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 24px;

  position: relative;
`

export const PetRegistration = styled.div`
  position: absolute;
  bottom: 10px;
  right: 10px;
  height: 40px;
  display: flex;
  align-items: center;
  padding-right: 16px;
  font-size: 1.8rem;
  line-height: 1.6rem;
  font-weight: 600;
  font-family: var(--font-family);
  color: var(--cobasi-blue-light-8);

  :before {
    content: url('${assetPrefix}/static/icons/plus.svg');
    width: 2.4rem;
    height: 2.4rem;
    margin-right: 8px;
  }

  :active {
    transition: 0.1s;
    opacity: 0.3;
  }

  :hover {
    transition: 0.3s;
    opacity: 0.8;
  }

  cursor: pointer;

  @media screen and (max-width: 1200px) {
    right: 50%;
    bottom: 36px;
    transform: translate(50%, 50%);
    width: 190px;
    padding: 0%;
  }
`

export const WrapperAdditionalServicesAndObs = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const CardBody = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;

  @media screen and (max-width: 1200px) {
    justify-content: flex-start;
    width: 100%;
  }
`
export const CardContent = styled.div`
  width: 100%;
  margin-left: 16px;

  @media screen and ${MOBILE_UP} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding-right: 16px;
  }

  @media screen and (max-width: 1200px) {
    margin-left: 16px;
    margin-right: 16px;
  }
`
export const PartnerBody = styled.div`
  width: 60%;
  margin-right: auto;

  @media screen and (max-width: 1200px) {
    margin-left:5px;
    width: 100%;
  }
`
export const PartnerRating = styled.div`
  margin-top: 8px;
  margin-right: 20px;

  .react-simple-star-rating span[title]{
    pointer-events: none;
    cursor: default;
  }

  svg {
    margin-right: 1px;
  }
`
export const LabelProfessional = styled.div`
  width: fit-content;
  color: var(--cobasi-blue-light-8);
  text-align: center;
  font-family: var(--primary-font);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 8px;
  cursor: pointer;

  label {
    cursor: pointer;
  }
`
export const SpanProfessional = styled.div`
  font-family: var(--primary-font);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 19.2px;
`

export const ProfessionalPhoto = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 64px;
    height: 64px;
    border-radius: 100%;
  }

  &.noPhoto {
    background-color: var(--light-slate);
    padding: 0px;
    display: flex;
    align-items: center;
    justify-content: center;

    img{
      width: 40px;
      height: 40px;
      border-radius: 0px;
      object-fit: none;
    }
  }
  @media (max-width: 1200px) {
    img {
      width: 40px;
      height: 40px;
    }
  }
`
export const MessageGroup = styled.div`
  width: 100%;
  margin-top: 20px;
`

export const CardBodyInvertSteps = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  @media screen and ${MOBILE} {
    justify-content: space-between;
    align-items: center;
  }
`

export const CardContentInvertSteps = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  margin-bottom: 0px;
  align-items: center;

  h2 {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: 0.96px;
    color: var(--gray-2);
  }

  p {
    font-family: var(--primary-font);
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 145%;
    color: var(--gray-5);
  }

  @media screen and ${MOBILE} {
    width: 100%;
    justify-content: start;
  }

  @media screen and (max-width: 768px) {
    margin: 0;
  }
`

export const WrapperTag = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
`

export const Tag = styled.div`
  height: 24px;
  width: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  padding: 0 12px;
  background-color: var(--neutral-gray);
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 145%;
`

export const RadioGroup = styled.div`
  margin-top: 1rem;
  max-width: 25rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  div > label {
    font-family: var(--primary-font);
    font-weight: 400;
    font-size: 14px;
    color: var(--gray-5);
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    margin: 0;
  }
`

export const Warning = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  gap: 16px;
  border-radius: 24px;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 145%;
  color: var(--gray-5);
  background-color: var(--pet-anjo-light-blue);
  margin: 24px 0;

  @media screen and (min-width: 762px) {
    flex: 1;
    margin: 0;
  }
`

export const WrapperRadio = styled.div`
  label {
    cursor: pointer;
  }
`

export const Card = styled.div`
  cursor: pointer;
  box-sizing: border-box;
  border-radius: 2.4rem;
  margin-bottom: ${props => props.marginBottom ? `${props.marginBottom}px` : '0'};
  position: relative;
  padding: 16px;
  background: var(--the-white);
  gap: 16px;
  width: 100%;
  ${props => props.active ? 'border: 2px solid var(--cobasi-blue-light-9);' : 'border: 1px solid var(--silver);'}

`
